import React from 'react';
import { Users, Clock, MousePointerClick, ChevronRight } from 'lucide-react';

function fmtHours(ms) {
  const h = (ms || 0) / 3_600_000;
  return h >= 1 ? `${h.toFixed(1)}h` : `${Math.round(h * 60)}m`;
}

const TYPE_LABEL = {
  director: 'Director', department: 'Department', service_area: 'Service area',
  manager: 'Manager', user: 'Person',
};

function Chip({ icon: Icon, value, tone, dark }) {
  const tones = {
    blue: dark ? 'text-blue-300 bg-blue-500/10' : 'text-blue-700 bg-blue-50',
    orange: dark ? 'text-orange-300 bg-orange-500/10' : 'text-orange-700 bg-orange-50',
    green: dark ? 'text-emerald-300 bg-emerald-500/10' : 'text-emerald-700 bg-emerald-50',
  };
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${tones[tone]}`}>
      <Icon size={13} />
      {value}
    </span>
  );
}

export default function UsageNodeList({ children, onDrill, theme }) {
  const dark = theme === 'dark';
  if (!children?.length) {
    return (
      <div className={`rounded-xl border p-8 text-center text-sm ${dark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'}`}>
        No sub-groups at this level.
      </div>
    );
  }
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {children.map(c => (
        <button
          key={`${c.type}:${c.id}`}
          onClick={() => onDrill(c)}
          className={`group flex items-center justify-between gap-3 px-4 py-3 rounded-xl border text-left transition-all ${
            dark
              ? 'border-gray-700 bg-gray-800/40 hover:bg-gray-800 hover:border-gray-600'
              : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-md'
          }`}
        >
          <div className="min-w-0">
            <div className={`text-[11px] uppercase tracking-wide ${dark ? 'text-gray-500' : 'text-gray-400'}`}>
              {TYPE_LABEL[c.type] || ''}
            </div>
            <div className="font-semibold truncate">{c.name || c.id}</div>
            <div className="flex flex-wrap gap-1.5 mt-2">
              <Chip icon={Users} value={`${c.metrics?.active_users ?? 0}`} tone="blue" dark={dark} />
              <Chip icon={Clock} value={fmtHours(c.metrics?.total_duration_ms)} tone="orange" dark={dark} />
              <Chip icon={MousePointerClick} value={`${c.metrics?.visits ?? 0}`} tone="green" dark={dark} />
            </div>
          </div>
          <ChevronRight
            size={18}
            className={`shrink-0 transition-transform group-hover:translate-x-0.5 ${dark ? 'text-gray-500' : 'text-gray-400'}`}
          />
        </button>
      ))}
    </div>
  );
}
